import types from './types';

const INITIAL_STATE = {
  isSaving: false,

  result: [],
};

const eligibilityHealthReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.SAVE_HEALTH_REQUEST:
      return {
        ...state,
        result: [],
        isSaving: true,
      };

    case types.SAVE_HEALTH_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isSaving: false,
      };

    case types.SAVE_HEALTH_FAILURE:
      return {
        ...state,
        result: [],
        isSaving: false,
      };

    default:
      return state;
  }
};

export default eligibilityHealthReducer;
